export enum Status {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PAID = 'paid',
  UNPAID = 'unpaid'
}
